module.exports = __webpack_public_path__ + "img/_dsc8180.8f8f9734.jpg";